import { Routes } from '@angular/router';

export const ourWorkRoutes: Routes = [
  {
    path: 'our-work',
    title: 'Our Work',
    loadComponent: () => import('./our-work.component').then(m => m.OurWorkComponent),
    children: [
      { path: '', redirectTo: 'support', pathMatch: 'full' },
      { path: 'donations', title: 'Food Access & Donations', loadComponent: () => import('../about-us/donations/donations.component').then(m => m.DonationsComponent) },
      { path: 'support', title: 'Supporting Farmers', loadComponent: () => import('../about-us/support/support.component').then(m => m.SupportComponent) },
      { path: 'packaging', title: 'Sustainable Packaging', loadComponent: () => import('../about-us/packaging/packaging.component').then(m => m.PackagingComponent) },
      { path: 'product-tags-and-navigation', title: 'Product Tags & Navigation', loadComponent: () => import('../how-it-works/product-tags-and-navigation/product-tags-and-navigation.component').then(m => m.ProductTagsAndNavigationComponent) },
    ],
  },
];
